import './styles.css';
import Navbar from './components/Navbar';
import CategoryShowcase from './components/CategoryShowcase';
import PromoBrandShowcase, { LatestProductsSection, TopSellersSection } from './components/PromoBrandShowcase';
import ShopByCategory from './components/ShopByCategory';
import ServiceHighlights from './components/ServiceHighlights';
import WholesalePartnerInfo from './components/WholesalePartnerInfo';
import FooterSection from './components/FooterSection';

function App() {
  return (
    <div className="app">
      <Navbar />
      
      <CategoryShowcase />
      <PromoBrandShowcase />
      <ShopByCategory />
      <TopSellersSection />
      <LatestProductsSection />
      <ServiceHighlights />
      <WholesalePartnerInfo />
      <FooterSection />
    </div>
  );
}

export default App
